import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/oneauth')({
  component: RouteComponent,
})

function RouteComponent() {
  // No PrivateRoute guard — this IS the session creation entry point.
  // The OneAuth component handles verifyOtp() to establish the session.
  return <Outlet />
}
